import { render, staticRenderFns } from "./TradeCounterPromoRegisterForAnAccount.vue?vue&type=template&id=017daa8a&"
import script from "./TradeCounterPromoRegisterForAnAccount.vue?vue&type=script&lang=js&"
export * from "./TradeCounterPromoRegisterForAnAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports